import { myStudioService } from '../StudioService/StudioService.connected';
import { createArrivalListService } from './ArrivalListService.impl';
import { createMockArrivalListService } from './ArrivalListService.mock';

export const myArrivalListService =
  localStorage.getItem('useMocks') === 'true'
    ? createMockArrivalListService()
    : createArrivalListService(myStudioService);
